<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2020-09-08',
        major: [],
        excepts: [],
        items: [

          // [NOTE] JP_JewelPact
          // ================================================================================

          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-001',
            rare        : 'SR',
            name        : 'ジュエルパクトピンクワンピ',
            imgUrl      : '/images/items/JP-001.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'PS',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-002',
            rare        : 'SR',
            name        : 'ジュエルパクトピンクシューズ',
            imgUrl      : '/images/items/JP-002.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-003',
            rare        : 'SR',
            name        : 'ジュエルパクトピンクヘアアクセ',
            imgUrl      : '/images/items/JP-003.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
          }),


          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-004',
            rare        : 'SR',
            name        : 'ジュエルパクトイエローワンピ',
            imgUrl      : '/images/items/JP-004.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'PS',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-005',
            rare        : 'SR',
            name        : 'ジュエルパクトイエローシューズ',
            imgUrl      : '/images/items/JP-005.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-006',
            rare        : 'SR',
            name        : 'ジュエルパクトイエローヘアアクセ',
            imgUrl      : '/images/items/JP-006.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
          }),


          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-007',
            rare        : 'SR',
            name        : 'ジュエルパクトブルーワンピ',
            imgUrl      : '/images/items/JP-007.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'PS',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-008',
            rare        : 'SR',
            name        : 'ジュエルパクトブルーシューズ',
            imgUrl      : '/images/items/JP-008.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-009',
            rare        : 'SR',
            name        : 'ジュエルパクトブルーヘアアクセ',
            imgUrl      : '/images/items/JP-009.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
          }),


          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-010',
            rare        : 'SR',
            name        : 'ジュエルパクトゴールドワンピ',
            imgUrl      : '/images/items/JP-010.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'PS',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-011',
            rare        : 'SR',
            name        : 'ジュエルパクトゴールドシューズ',
            imgUrl      : '/images/items/JP-011.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-012',
            rare        : 'SR',
            name        : 'ジュエルパクトゴールドヘアアクセ',
            imgUrl      : '/images/items/JP-012.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
          }),


          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-013',
            rare        : 'SR',
            name        : 'ジュエルパクトブラックワンピ',
            imgUrl      : '/images/items/JP-013.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'PS',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-014',
            rare        : 'SR',
            name        : 'ジュエルパクトブラックシューズ',
            imgUrl      : '/images/items/JP-014.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-015',
            rare        : 'SR',
            name        : 'ジュエルパクトブラックヘアアクセ',
            imgUrl      : '/images/items/JP-015.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
          }),


          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-044',
            rare        : 'SR',
            name        : 'ジュエルパクトレッドワンピ',
            imgUrl      : '/images/items/JP-044.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-045',
            rare        : 'SR',
            name        : 'ジュエルパクトレッドシューズ',
            imgUrl      : '/images/items/JP-045.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-046',
            rare        : 'SR',
            name        : 'ジュエルパクトレッドヘアアクセ',
            imgUrl      : '/images/items/JP-046.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
          }),


          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-047',
            rare        : 'SR',
            name        : 'ジュエルパクトグリーンワンピ',
            imgUrl      : '/images/items/JP-047.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-048',
            rare        : 'SR',
            name        : 'ジュエルパクトグリーンシューズ',
            imgUrl      : '/images/items/JP-048.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-049',
            rare        : 'SR',
            name        : 'ジュエルパクトグリーンヘアアクセ',
            imgUrl      : '/images/items/JP-049.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
          }),


          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-050',
            rare        : 'SR',
            name        : 'ジュエルパクトパープルワンピ',
            imgUrl      : '/images/items/JP-050.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-051',
            rare        : 'SR',
            name        : 'ジュエルパクトパープルシューズ',
            imgUrl      : '/images/items/JP-051.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-052',
            rare        : 'SR',
            name        : 'ジュエルパクトパープルヘアアクセ',
            imgUrl      : '/images/items/JP-052.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
          }),


          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-111',
            rare        : 'SR',
            name        : 'ジュエルパクトホワイトワンピ',
            imgUrl      : '/images/items/JP-111.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-112',
            rare        : 'SR',
            name        : 'ジュエルパクトホワイトシューズ',
            imgUrl      : '/images/items/JP-112.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-113',
            rare        : 'SR',
            name        : 'ジュエルパクトホワイトヘアアクセ',
            imgUrl      : '/images/items/JP-113.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
          }),


          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-114',
            rare        : 'SR',
            name        : 'ジュエルパクトレインボーワンピ',
            imgUrl      : '/images/items/JP-114.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'PS',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-115',
            rare        : 'SR',
            name        : 'ジュエルパクトレインボーシューズ',
            imgUrl      : '/images/items/JP-115.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
            id          : 'JP-116',
            rare        : 'SR',
            name        : 'ジュエルパクトレインボーヘアアクセ',
            imgUrl      : '/images/items/JP-116.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPact',
          }),


          // [NOTE] JP_PritickePack01
          // ================================================================================

          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-016',
            rare        : 'SR',
            name        : 'フラワーパーティーピンクトップス',
            imgUrl      : '/images/items/JP-016.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-017',
            rare        : 'SR',
            name        : 'フラワーパーティーピンクスカート',
            imgUrl      : '/images/items/JP-017.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-018',
            rare        : 'SR',
            name        : 'フラワーパーティーピンクシューズ',
            imgUrl      : '/images/items/JP-018.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-019',
            rare        : 'SR',
            name        : 'フラワーパーティーピンクヘアアクセ',
            imgUrl      : '/images/items/JP-019.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-020',
            rare        : 'SR',
            name        : 'フラワーパーティーイエロートップス',
            imgUrl      : '/images/items/JP-020.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-021',
            rare        : 'SR',
            name        : 'フラワーパーティーイエロースカート',
            imgUrl      : '/images/items/JP-021.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-022',
            rare        : 'SR',
            name        : 'フラワーパーティーイエローシューズ',
            imgUrl      : '/images/items/JP-022.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-023',
            rare        : 'SR',
            name        : 'フラワーパーティーイエローヘアアクセ',
            imgUrl      : '/images/items/JP-023.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-024',
            rare        : 'SR',
            name        : 'フラワーパーティーブルートップス',
            imgUrl      : '/images/items/JP-024.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-025',
            rare        : 'SR',
            name        : 'フラワーパーティーブルースカート',
            imgUrl      : '/images/items/JP-025.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-026',
            rare        : 'SR',
            name        : 'フラワーパーティーブルーシューズ',
            imgUrl      : '/images/items/JP-026.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-027',
            rare        : 'SR',
            name        : 'フラワーパーティーブルーヘアアクセ',
            imgUrl      : '/images/items/JP-027.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-028',
            rare        : 'SR',
            name        : 'フラワーパーティーゴールドトップス',
            imgUrl      : '/images/items/JP-028.png',
            kind        : 'トップス',
            color       : '金',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-029',
            rare        : 'SR',
            name        : 'フラワーパーティーゴールドスカート',
            imgUrl      : '/images/items/JP-029.png',
            kind        : 'ボトムス',
            color       : '金',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-030',
            rare        : 'SR',
            name        : 'フラワーパーティーゴールドシューズ',
            imgUrl      : '/images/items/JP-030.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-031',
            rare        : 'SR',
            name        : 'フラワーパーティーゴールドヘアアクセ',
            imgUrl      : '/images/items/JP-031.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-032',
            rare        : 'SR',
            name        : 'フラワーパーティーブラックトップス',
            imgUrl      : '/images/items/JP-032.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-033',
            rare        : 'SR',
            name        : 'フラワーパーティーブラックスカート',
            imgUrl      : '/images/items/JP-033.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-034',
            rare        : 'SR',
            name        : 'フラワーパーティーブラックシューズ',
            imgUrl      : '/images/items/JP-034.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-035',
            rare        : 'SR',
            name        : 'フラワーパーティーブラックヘアアクセ',
            imgUrl      : '/images/items/JP-035.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-053',
            rare        : 'SR',
            name        : 'フラワーパーティーレッドトップス',
            imgUrl      : '/images/items/JP-053.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-054',
            rare        : 'SR',
            name        : 'フラワーパーティーレッドスカート',
            imgUrl      : '/images/items/JP-054.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-055',
            rare        : 'SR',
            name        : 'フラワーパーティーレッドシューズ',
            imgUrl      : '/images/items/JP-055.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-056',
            rare        : 'SR',
            name        : 'フラワーパーティーレッドヘアアクセ',
            imgUrl      : '/images/items/JP-056.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-057',
            rare        : 'SR',
            name        : 'フラワーパーティーグリーントップス',
            imgUrl      : '/images/items/JP-057.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-058',
            rare        : 'SR',
            name        : 'フラワーパーティーグリーンスカート',
            imgUrl      : '/images/items/JP-058.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-059',
            rare        : 'SR',
            name        : 'フラワーパーティーグリーンシューズ',
            imgUrl      : '/images/items/JP-059.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-060',
            rare        : 'SR',
            name        : 'フラワーパーティーグリーンヘアアクセ',
            imgUrl      : '/images/items/JP-060.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-061',
            rare        : 'SR',
            name        : 'フラワーパーティーパープルトップス',
            imgUrl      : '/images/items/JP-061.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-062',
            rare        : 'SR',
            name        : 'フラワーパーティーパープルスカート',
            imgUrl      : '/images/items/JP-062.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-063',
            rare        : 'SR',
            name        : 'フラワーパーティーパープルシューズ',
            imgUrl      : '/images/items/JP-063.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-064',
            rare        : 'SR',
            name        : 'フラワーパーティーパープルヘアアクセ',
            imgUrl      : '/images/items/JP-064.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-117',
            rare        : 'SR',
            name        : 'フラワーパーティーホワイトトップス',
            imgUrl      : '/images/items/JP-117.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-118',
            rare        : 'SR',
            name        : 'フラワーパーティーホワイトスカート',
            imgUrl      : '/images/items/JP-118.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-119',
            rare        : 'SR',
            name        : 'フラワーパーティーホワイトシューズ',
            imgUrl      : '/images/items/JP-119.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-120',
            rare        : 'SR',
            name        : 'フラワーパーティーホワイトヘアアクセ',
            imgUrl      : '/images/items/JP-120.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-121',
            rare        : 'SR',
            name        : 'フラワーパーティーレインボートップス',
            imgUrl      : '/images/items/JP-121.png',
            kind        : 'トップス',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-122',
            rare        : 'SR',
            name        : 'フラワーパーティーレインボースカート',
            imgUrl      : '/images/items/JP-122.png',
            kind        : 'ボトムス',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-123',
            rare        : 'SR',
            name        : 'フラワーパーティーレインボーシューズ',
            imgUrl      : '/images/items/JP-123.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack01',
            id          : 'JP-124',
            rare        : 'SR',
            name        : 'フラワーパーティーレインボーヘアアクセ',
            imgUrl      : '/images/items/JP-124.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_PritickePack02
          // ================================================================================

          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-069',
            rare        : 'SR',
            name        : 'チアリーダーパクトピンクトップス',
            imgUrl      : '/images/items/JP-069.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-070',
            rare        : 'SR',
            name        : 'チアリーダーパクトピンクスカート',
            imgUrl      : '/images/items/JP-070.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-071',
            rare        : 'SR',
            name        : 'チアリーダーパクトピンクシューズ',
            imgUrl      : '/images/items/JP-071.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-072',
            rare        : 'SR',
            name        : 'チアリーダーパクトピンクヘアアクセ',
            imgUrl      : '/images/items/JP-072.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-073',
            rare        : 'SR',
            name        : 'チアリーダーパクトイエロートップス',
            imgUrl      : '/images/items/JP-073.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-074',
            rare        : 'SR',
            name        : 'チアリーダーパクトイエロースカート',
            imgUrl      : '/images/items/JP-074.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-075',
            rare        : 'SR',
            name        : 'チアリーダーパクトイエローシューズ',
            imgUrl      : '/images/items/JP-075.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-076',
            rare        : 'SR',
            name        : 'チアリーダーパクトイエローヘアアクセ',
            imgUrl      : '/images/items/JP-076.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-077',
            rare        : 'SR',
            name        : 'チアリーダーパクトブルートップス',
            imgUrl      : '/images/items/JP-077.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-078',
            rare        : 'SR',
            name        : 'チアリーダーパクトブルースカート',
            imgUrl      : '/images/items/JP-078.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-079',
            rare        : 'SR',
            name        : 'チアリーダーパクトブルーシューズ',
            imgUrl      : '/images/items/JP-079.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-080',
            rare        : 'SR',
            name        : 'チアリーダーパクトブルーヘアアクセ',
            imgUrl      : '/images/items/JP-080.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-081',
            rare        : 'SR',
            name        : 'チアリーダーパクトゴールドトップス',
            imgUrl      : '/images/items/JP-081.png',
            kind        : 'トップス',
            color       : '金',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-082',
            rare        : 'SR',
            name        : 'チアリーダーパクトゴールドスカート',
            imgUrl      : '/images/items/JP-082.png',
            kind        : 'ボトムス',
            color       : '金',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-083',
            rare        : 'SR',
            name        : 'チアリーダーパクトゴールドシューズ',
            imgUrl      : '/images/items/JP-083.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-084',
            rare        : 'SR',
            name        : 'チアリーダーパクトゴールドヘアアクセ',
            imgUrl      : '/images/items/JP-084.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-085',
            rare        : 'SR',
            name        : 'チアリーダーパクトブラックトップス',
            imgUrl      : '/images/items/JP-085.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-086',
            rare        : 'SR',
            name        : 'チアリーダーパクトブラックスカート',
            imgUrl      : '/images/items/JP-086.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-087',
            rare        : 'SR',
            name        : 'チアリーダーパクトブラックシューズ',
            imgUrl      : '/images/items/JP-087.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-088',
            rare        : 'SR',
            name        : 'チアリーダーパクトブラックヘアアクセ',
            imgUrl      : '/images/items/JP-088.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-089',
            rare        : 'SR',
            name        : 'チアリーダーパクトレッドトップス',
            imgUrl      : '/images/items/JP-089.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-090',
            rare        : 'SR',
            name        : 'チアリーダーパクトレッドスカート',
            imgUrl      : '/images/items/JP-090.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-091',
            rare        : 'SR',
            name        : 'チアリーダーパクトレッドシューズ',
            imgUrl      : '/images/items/JP-091.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-092',
            rare        : 'SR',
            name        : 'チアリーダーパクトレッドヘアアクセ',
            imgUrl      : '/images/items/JP-092.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-093',
            rare        : 'SR',
            name        : 'チアリーダーパクトグリーントップス',
            imgUrl      : '/images/items/JP-093.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-094',
            rare        : 'SR',
            name        : 'チアリーダーパクトグリーンスカート',
            imgUrl      : '/images/items/JP-094.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-095',
            rare        : 'SR',
            name        : 'チアリーダーパクトグリーンシューズ',
            imgUrl      : '/images/items/JP-095.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-096',
            rare        : 'SR',
            name        : 'チアリーダーパクトグリーンヘアアクセ',
            imgUrl      : '/images/items/JP-096.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-097',
            rare        : 'SR',
            name        : 'チアリーダーパクトパープルトップス',
            imgUrl      : '/images/items/JP-097.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-098',
            rare        : 'SR',
            name        : 'チアリーダーパクトパープルスカート',
            imgUrl      : '/images/items/JP-098.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-099',
            rare        : 'SR',
            name        : 'チアリーダーパクトパープルシューズ',
            imgUrl      : '/images/items/JP-099.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-100',
            rare        : 'SR',
            name        : 'チアリーダーパクトパープルヘアアクセ',
            imgUrl      : '/images/items/JP-100.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-125',
            rare        : 'SR',
            name        : 'チアリーダーパクトホワイトトップス',
            imgUrl      : '/images/items/JP-125.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-126',
            rare        : 'SR',
            name        : 'チアリーダーパクトホワイトスカート',
            imgUrl      : '/images/items/JP-126.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-127',
            rare        : 'SR',
            name        : 'チアリーダーパクトホワイトシューズ',
            imgUrl      : '/images/items/JP-127.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-128',
            rare        : 'SR',
            name        : 'チアリーダーパクトホワイトヘアアクセ',
            imgUrl      : '/images/items/JP-128.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-129',
            rare        : 'SR',
            name        : 'チアリーダーパクトレインボートップス',
            imgUrl      : '/images/items/JP-129.png',
            kind        : 'トップス',
            color       : '虹',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-130',
            rare        : 'SR',
            name        : 'チアリーダーパクトレインボースカート',
            imgUrl      : '/images/items/JP-130.png',
            kind        : 'ボトムス',
            color       : '虹',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-131',
            rare        : 'SR',
            name        : 'チアリーダーパクトレインボーシューズ',
            imgUrl      : '/images/items/JP-131.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack02',
            id          : 'JP-132',
            rare        : 'SR',
            name        : 'チアリーダーパクトレインボーヘアアクセ',
            imgUrl      : '/images/items/JP-132.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_PritickePack03
          // ================================================================================

          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-133',
            rare        : 'SR',
            name        : 'エジプトクイーンピンクトップス',
            imgUrl      : '/images/items/JP-133.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-134',
            rare        : 'SR',
            name        : 'エジプトクイーンピンクスカート',
            imgUrl      : '/images/items/JP-134.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-135',
            rare        : 'SR',
            name        : 'エジプトクイーンピンクシューズ',
            imgUrl      : '/images/items/JP-135.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-136',
            rare        : 'SR',
            name        : 'エジプトクイーンピンクヘアアクセ',
            imgUrl      : '/images/items/JP-136.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-137',
            rare        : 'SR',
            name        : 'エジプトクイーンイエロートップス',
            imgUrl      : '/images/items/JP-137.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-138',
            rare        : 'SR',
            name        : 'エジプトクイーンイエロースカート',
            imgUrl      : '/images/items/JP-138.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-139',
            rare        : 'SR',
            name        : 'エジプトクイーンイエローシューズ',
            imgUrl      : '/images/items/JP-139.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-140',
            rare        : 'SR',
            name        : 'エジプトクイーンイエローヘアアクセ',
            imgUrl      : '/images/items/JP-140.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-141',
            rare        : 'SR',
            name        : 'エジプトクイーンブルートップス',
            imgUrl      : '/images/items/JP-141.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-142',
            rare        : 'SR',
            name        : 'エジプトクイーンブルースカート',
            imgUrl      : '/images/items/JP-142.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-143',
            rare        : 'SR',
            name        : 'エジプトクイーンブルーシューズ',
            imgUrl      : '/images/items/JP-143.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-144',
            rare        : 'SR',
            name        : 'エジプトクイーンブルーヘアアクセ',
            imgUrl      : '/images/items/JP-144.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-145',
            rare        : 'SR',
            name        : 'エジプトクイーンゴールドトップス',
            imgUrl      : '/images/items/JP-145.png',
            kind        : 'トップス',
            color       : '金',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-146',
            rare        : 'SR',
            name        : 'エジプトクイーンゴールドスカート',
            imgUrl      : '/images/items/JP-146.png',
            kind        : 'ボトムス',
            color       : '金',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-147',
            rare        : 'SR',
            name        : 'エジプトクイーンゴールドシューズ',
            imgUrl      : '/images/items/JP-147.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-148',
            rare        : 'SR',
            name        : 'エジプトクイーンゴールドヘアアクセ',
            imgUrl      : '/images/items/JP-148.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-149',
            rare        : 'SR',
            name        : 'エジプトクイーンブラックトップス',
            imgUrl      : '/images/items/JP-149.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-150',
            rare        : 'SR',
            name        : 'エジプトクイーンブラックスカート',
            imgUrl      : '/images/items/JP-150.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-151',
            rare        : 'SR',
            name        : 'エジプトクイーンブラックシューズ',
            imgUrl      : '/images/items/JP-151.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-152',
            rare        : 'SR',
            name        : 'エジプトクイーンブラックヘアアクセ',
            imgUrl      : '/images/items/JP-152.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-153',
            rare        : 'SR',
            name        : 'エジプトクイーンレッドトップス',
            imgUrl      : '/images/items/JP-153.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-154',
            rare        : 'SR',
            name        : 'エジプトクイーンレッドスカート',
            imgUrl      : '/images/items/JP-154.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-155',
            rare        : 'SR',
            name        : 'エジプトクイーンレッドシューズ',
            imgUrl      : '/images/items/JP-155.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-156',
            rare        : 'SR',
            name        : 'エジプトクイーンレッドヘアアクセ',
            imgUrl      : '/images/items/JP-156.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-157',
            rare        : 'SR',
            name        : 'エジプトクイーングリーントップス',
            imgUrl      : '/images/items/JP-157.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-158',
            rare        : 'SR',
            name        : 'エジプトクイーングリーンスカート',
            imgUrl      : '/images/items/JP-158.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-159',
            rare        : 'SR',
            name        : 'エジプトクイーングリーンシューズ',
            imgUrl      : '/images/items/JP-159.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-160',
            rare        : 'SR',
            name        : 'エジプトクイーングリーンヘアアクセ',
            imgUrl      : '/images/items/JP-160.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-161',
            rare        : 'SR',
            name        : 'エジプトクイーンパープルトップス',
            imgUrl      : '/images/items/JP-161.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-162',
            rare        : 'SR',
            name        : 'エジプトクイーンパープルスカート',
            imgUrl      : '/images/items/JP-162.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-163',
            rare        : 'SR',
            name        : 'エジプトクイーンパープルシューズ',
            imgUrl      : '/images/items/JP-163.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-164',
            rare        : 'SR',
            name        : 'エジプトクイーンパープルヘアアクセ',
            imgUrl      : '/images/items/JP-164.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-165',
            rare        : 'SR',
            name        : 'エジプトクイーンホワイトトップス',
            imgUrl      : '/images/items/JP-165.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-166',
            rare        : 'SR',
            name        : 'エジプトクイーンホワイトスカート',
            imgUrl      : '/images/items/JP-166.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-167',
            rare        : 'SR',
            name        : 'エジプトクイーンホワイトシューズ',
            imgUrl      : '/images/items/JP-167.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-168',
            rare        : 'SR',
            name        : 'エジプトクイーンホワイトヘアアクセ',
            imgUrl      : '/images/items/JP-168.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-169',
            rare        : 'SR',
            name        : 'エジプトクイーンレインボートップス',
            imgUrl      : '/images/items/JP-169.png',
            kind        : 'トップス',
            color       : '虹',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-170',
            rare        : 'SR',
            name        : 'エジプトクイーンレインボースカート',
            imgUrl      : '/images/items/JP-170.png',
            kind        : 'ボトムス',
            color       : '虹',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-171',
            rare        : 'SR',
            name        : 'エジプトクイーンレインボーシューズ',
            imgUrl      : '/images/items/JP-171.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_PritickePack03',
            id          : 'JP-172',
            rare        : 'SR',
            name        : 'エジプトクイーンレインボーヘアアクセ',
            imgUrl      : '/images/items/JP-172.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_KiraKiraPack0102
          // ================================================================================

          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-180',
            rare        : 'SR',
            name        : 'ミステリアスキャットピンクトップス',
            imgUrl      : '/images/items/JP-180.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-181',
            rare        : 'SR',
            name        : 'ミステリアスキャットピンクパンツ',
            imgUrl      : '/images/items/JP-181.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-182',
            rare        : 'SR',
            name        : 'ミステリアスキャットピンクシューズ',
            imgUrl      : '/images/items/JP-182.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-183',
            rare        : 'SR',
            name        : 'ミステリアスキャットピンクヘアアクセ',
            imgUrl      : '/images/items/JP-183.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-184',
            rare        : 'SR',
            name        : 'ミステリアスキャットイエロートップス',
            imgUrl      : '/images/items/JP-184.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-185',
            rare        : 'SR',
            name        : 'ミステリアスキャットイエローパンツ',
            imgUrl      : '/images/items/JP-185.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-186',
            rare        : 'SR',
            name        : 'ミステリアスキャットイエローシューズ',
            imgUrl      : '/images/items/JP-186.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-187',
            rare        : 'SR',
            name        : 'ミステリアスキャットイエローヘアアクセ',
            imgUrl      : '/images/items/JP-187.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-188',
            rare        : 'SR',
            name        : 'ミステリアスキャットブルートップス',
            imgUrl      : '/images/items/JP-188.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-189',
            rare        : 'SR',
            name        : 'ミステリアスキャットブルーパンツ',
            imgUrl      : '/images/items/JP-189.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-190',
            rare        : 'SR',
            name        : 'ミステリアスキャットブルーシューズ',
            imgUrl      : '/images/items/JP-190.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-191',
            rare        : 'SR',
            name        : 'ミステリアスキャットブルーヘアアクセ',
            imgUrl      : '/images/items/JP-191.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-192',
            rare        : 'SR',
            name        : 'ミステリアスキャットゴールドトップス',
            imgUrl      : '/images/items/JP-192.png',
            kind        : 'トップス',
            color       : '金',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-193',
            rare        : 'SR',
            name        : 'ミステリアスキャットゴールドパンツ',
            imgUrl      : '/images/items/JP-193.png',
            kind        : 'ボトムス',
            color       : '金',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-194',
            rare        : 'SR',
            name        : 'ミステリアスキャットゴールドシューズ',
            imgUrl      : '/images/items/JP-194.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-195',
            rare        : 'SR',
            name        : 'ミステリアスキャットゴールドヘアアクセ',
            imgUrl      : '/images/items/JP-195.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-196',
            rare        : 'SR',
            name        : 'ミステリアスキャットブラックトップス',
            imgUrl      : '/images/items/JP-196.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-197',
            rare        : 'SR',
            name        : 'ミステリアスキャットブラックパンツ',
            imgUrl      : '/images/items/JP-197.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-198',
            rare        : 'SR',
            name        : 'ミステリアスキャットブラックシューズ',
            imgUrl      : '/images/items/JP-198.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-199',
            rare        : 'SR',
            name        : 'ミステリアスキャットブラックヘアアクセ',
            imgUrl      : '/images/items/JP-199.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-200',
            rare        : 'SR',
            name        : 'ミステリアスキャットレッドトップス',
            imgUrl      : '/images/items/JP-200.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-201',
            rare        : 'SR',
            name        : 'ミステリアスキャットレッドパンツ',
            imgUrl      : '/images/items/JP-201.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-202',
            rare        : 'SR',
            name        : 'ミステリアスキャットレッドシューズ',
            imgUrl      : '/images/items/JP-202.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-203',
            rare        : 'SR',
            name        : 'ミステリアスキャットレッドヘアアクセ',
            imgUrl      : '/images/items/JP-203.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-204',
            rare        : 'SR',
            name        : 'ミステリアスキャットグリーントップス',
            imgUrl      : '/images/items/JP-204.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-205',
            rare        : 'SR',
            name        : 'ミステリアスキャットグリーンパンツ',
            imgUrl      : '/images/items/JP-205.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-206',
            rare        : 'SR',
            name        : 'ミステリアスキャットグリーンシューズ',
            imgUrl      : '/images/items/JP-206.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-207',
            rare        : 'SR',
            name        : 'ミステリアスキャットグリーンヘアアクセ',
            imgUrl      : '/images/items/JP-207.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-208',
            rare        : 'SR',
            name        : 'ミステリアスキャットパープルトップス',
            imgUrl      : '/images/items/JP-208.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-209',
            rare        : 'SR',
            name        : 'ミステリアスキャットパープルパンツ',
            imgUrl      : '/images/items/JP-209.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-210',
            rare        : 'SR',
            name        : 'ミステリアスキャットパープルシューズ',
            imgUrl      : '/images/items/JP-210.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-211',
            rare        : 'SR',
            name        : 'ミステリアスキャットパープルヘアアクセ',
            imgUrl      : '/images/items/JP-211.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-212',
            rare        : 'SR',
            name        : 'ミステリアスキャットホワイトトップス',
            imgUrl      : '/images/items/JP-212.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-213',
            rare        : 'SR',
            name        : 'ミステリアスキャットホワイトパンツ',
            imgUrl      : '/images/items/JP-213.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-214',
            rare        : 'SR',
            name        : 'ミステリアスキャットホワイトシューズ',
            imgUrl      : '/images/items/JP-214.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-215',
            rare        : 'SR',
            name        : 'ミステリアスキャットホワイトヘアアクセ',
            imgUrl      : '/images/items/JP-215.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-216',
            rare        : 'SR',
            name        : 'ミステリアスキャットレインボートップス',
            imgUrl      : '/images/items/JP-216.png',
            kind        : 'トップス',
            color       : '虹',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-217',
            rare        : 'SR',
            name        : 'ミステリアスキャットレインボーパンツ',
            imgUrl      : '/images/items/JP-217.png',
            kind        : 'ボトムス',
            color       : '虹',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-218',
            rare        : 'SR',
            name        : 'ミステリアスキャットレインボーシューズ',
            imgUrl      : '/images/items/JP-218.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_KiraKiraPack0102',
            id          : 'JP-219',
            rare        : 'SR',
            name        : 'ミステリアスキャットレインボーヘアアクセ',
            imgUrl      : '/images/items/JP-219.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_Jewel01
          // ================================================================================

          item({
            collection  : 'JP_Jewel01',
            id          : 'JP-036',
            rare        : 'SR',
            name        : 'さくらひめあさぎトップス',
            imgUrl      : '/images/items/JP-036.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),

          item({
            collection  : 'JP_Jewel01',
            id          : 'JP-037',
            rare        : 'SR',
            name        : 'さくらひめあさぎスカート',
            imgUrl      : '/images/items/JP-037.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),

          item({
            collection  : 'JP_Jewel01',
            id          : 'JP-038',
            rare        : 'SR',
            name        : 'さくらひめあさぎシューズ',
            imgUrl      : '/images/items/JP-038.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),

          item({
            collection  : 'JP_Jewel01',
            id          : 'JP-039',
            rare        : 'SR',
            name        : 'さくらひめあさぎヘアアクセ',
            imgUrl      : '/images/items/JP-039.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_Jewel02
          // ================================================================================

          item({
            collection  : 'JP_Jewel02',
            id          : 'JP-040',
            rare        : 'SR',
            name        : 'ロータスチャイナグリーンブラウス',
            imgUrl      : '/images/items/JP-040.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel02',
            id          : 'JP-041',
            rare        : 'SR',
            name        : 'ロータスチャイナグリーンスカート',
            imgUrl      : '/images/items/JP-041.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel02',
            id          : 'JP-042',
            rare        : 'SR',
            name        : 'ロータスチャイナグリーンシューズ',
            imgUrl      : '/images/items/JP-042.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel02',
            id          : 'JP-043',
            rare        : 'SR',
            name        : 'ロータスチャイナグリーンヘアアクセ',
            imgUrl      : '/images/items/JP-043.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),



          // [NOTE] JP_Jewel03
          // ================================================================================

          item({
            collection  : 'JP_Jewel03',
            id          : 'JP-065',
            rare        : 'SR',
            name        : 'カラフルクッキングトマトトップス',
            imgUrl      : '/images/items/JP-065.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel03',
            id          : 'JP-066',
            rare        : 'SR',
            name        : 'カラフルクッキングトマトスカート',
            imgUrl      : '/images/items/JP-066.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel03',
            id          : 'JP-067',
            rare        : 'SR',
            name        : 'カラフルクッキングトマトシューズ',
            imgUrl      : '/images/items/JP-067.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel03',
            id          : 'JP-068',
            rare        : 'SR',
            name        : 'カラフルクッキングトマトヘアアクセ',
            imgUrl      : '/images/items/JP-068.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_Jewel04
          // ================================================================================

          item({
            collection  : 'JP_Jewel04',
            id          : 'JP-107',
            rare        : 'SR',
            name        : 'ティーパーティーレモントップス',
            imgUrl      : '/images/items/JP-107.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel04',
            id          : 'JP-108',
            rare        : 'SR',
            name        : 'ティーパーティーレモンスカート',
            imgUrl      : '/images/items/JP-108.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel04',
            id          : 'JP-109',
            rare        : 'SR',
            name        : 'ティーパーティーレモンシューズ',
            imgUrl      : '/images/items/JP-109.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel04',
            id          : 'JP-110',
            rare        : 'SR',
            name        : 'ティーパーティーレモンヘアアクセ',
            imgUrl      : '/images/items/JP-110.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_Jewel05
          // ================================================================================

          item({
            collection  : 'JP_Jewel05',
            id          : 'JP-220',
            rare        : 'SR',
            name        : 'ヒップホップダンスライムトップス',
            imgUrl      : '/images/items/JP-220.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel05',
            id          : 'JP-221',
            rare        : 'SR',
            name        : 'ヒップホップダンスライムパンツ',
            imgUrl      : '/images/items/JP-221.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel05',
            id          : 'JP-222',
            rare        : 'SR',
            name        : 'ヒップホップダンスライムシューズ',
            imgUrl      : '/images/items/JP-222.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel05',
            id          : 'JP-223',
            rare        : 'SR',
            name        : 'ヒップホップダンスライムヘアアクセ',
            imgUrl      : '/images/items/JP-223.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_Jewel06
          // ================================================================================

          item({
            collection  : 'JP_Jewel06',
            id          : 'JP-224',
            rare        : 'SR',
            name        : 'レインボーライブプリズムトップス',
            imgUrl      : '/images/items/JP-224.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'DC',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel06',
            id          : 'JP-225',
            rare        : 'SR',
            name        : 'レインボーライブプリズムスカート',
            imgUrl      : '/images/items/JP-225.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'DC',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel06',
            id          : 'JP-226',
            rare        : 'SR',
            name        : 'レインボーライブプリズムシューズ',
            imgUrl      : '/images/items/JP-226.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'DC',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_Jewel06',
            id          : 'JP-227',
            rare        : 'SR',
            name        : 'レインボーライブプリズムヘアアクセ',
            imgUrl      : '/images/items/JP-227.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'DC',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_FCDXSet2
          // ================================================================================

          item({
            collection  : 'JP_FCDXSet2',
            id          : 'JP-176',
            rare        : 'SR',
            name        : 'ホーンテッドヴァンパイアレッドトップス',
            imgUrl      : '/images/items/JP-176.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_FCDXSet2',
            id          : 'JP-177',
            rare        : 'SR',
            name        : 'ホーンテッドヴァンパイアレッドスカート',
            imgUrl      : '/images/items/JP-177.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_FCDXSet2',
            id          : 'JP-178',
            rare        : 'SR',
            name        : 'ホーンテッドヴァンパイアレッドシューズ',
            imgUrl      : '/images/items/JP-178.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_FCDXSet2',
            id          : 'JP-179',
            rare        : 'SR',
            name        : 'ホーンテッドヴァンパイアレッドヘアアクセ',
            imgUrl      : '/images/items/JP-179.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_JewelPactBenefit
          // ================================================================================

          item({
            collection  : 'JP_JewelPactBenefit',
            id          : 'P-072',
            rare        : 'SR',
            name        : 'ハッピースウィムトリコロールワンピ',
            imgUrl      : '/images/items/P-072.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPactBenefit',
            id          : 'P-073',
            rare        : 'SR',
            name        : 'ハッピースウィムトリコロールシューズ',
            imgUrl      : '/images/items/P-073.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPactBenefit',
            id          : 'P-074',
            rare        : 'SR',
            name        : 'ハッピースウィムトリコロールヘアアクセ',
            imgUrl      : '/images/items/P-074.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_JewelPactBenefit',
          }),


          // [NOTE] JP_DP_SherbetPink
          // ================================================================================

          item({
            collection  : 'JP_DP_SherbetPink',
            id          : 'JP-101',
            rare        : 'KR',
            name        : 'ミラクル☆キラッツイエローグループキラッとワンピ',
            imgUrl      : '/images/items/JP-101.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 1570,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_DP_SherbetPink',
            id          : 'JP-102',
            rare        : 'KR',
            name        : 'ミラクル☆キラッツイエローグループキラッとシューズ',
            imgUrl      : '/images/items/JP-102.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_DP_SherbetPink',
            id          : 'JP-103',
            rare        : 'KR',
            name        : 'ミラクル☆キラッツイエローグループキラッとヘアアクセ',
            imgUrl      : '/images/items/JP-103.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_DP_SherbetPink',
          }),


          // [NOTE] JP_DP_EternalWhite
          // ================================================================================

          item({
            collection  : 'JP_DP_EternalWhite',
            id          : 'JP-104',
            rare        : 'KR',
            name        : 'メルティックスターロックグループキラッとワンピ',
            imgUrl      : '/images/items/JP-104.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 1570,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_DP_EternalWhite',
            id          : 'JP-105',
            rare        : 'KR',
            name        : 'メルティックスターロックグループキラッとシューズ',
            imgUrl      : '/images/items/JP-105.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_DP_EternalWhite',
            id          : 'JP-106',
            rare        : 'KR',
            name        : 'メルティックスターロックグループキラッとヘアアクセ',
            imgUrl      : '/images/items/JP-106.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_DP_EternalWhite',
          }),


          // [NOTE] JP_DP_JewelPink
          // ================================================================================

          item({
            collection  : 'JP_DP_JewelPink',
            id          : 'JP-173',
            rare        : 'KR',
            name        : 'アイランジュブルーキラッとワンピ',
            imgUrl      : '/images/items/JP-173.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 1570,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_DP_JewelPink',
            id          : 'JP-174',
            rare        : 'KR',
            name        : 'アイランジュブルーキラッとシューズ',
            imgUrl      : '/images/items/JP-174.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_DP_JewelPink',
            id          : 'JP-175',
            rare        : 'KR',
            name        : 'アイランジュブルーキラッとヘアアクセ',
            imgUrl      : '/images/items/JP-175.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JP_DP_JewelPink',
          }),


        ]
      }
    },

    computed: {
      itemsJewelPact () {
        return _.where(this.items, { collection: 'JP_JewelPact' })
      },

      itemsPritickePack01 () {
        return _.where(this.items, { collection: 'JP_PritickePack01' })
      },

      itemsPritickePack02 () {
        return _.where(this.items, { collection: 'JP_PritickePack02' })
      },

      itemsPritickePack03 () {
        return _.where(this.items, { collection: 'JP_PritickePack03' })
      },

      itemsKiraKiraPack0102 () {
        return _.where(this.items, { collection: 'JP_KiraKiraPack0102' })
      },

      itemsJewel01 () {
        return _.where(this.items, { collection: 'JP_Jewel01' })
      },

      itemsJewel02 () {
        return _.where(this.items, { collection: 'JP_Jewel02' })
      },

      itemsJewel03 () {
        return _.where(this.items, { collection: 'JP_Jewel03' })
      },

      itemsJewel04 () {
        return _.where(this.items, { collection: 'JP_Jewel04' })
      },

      itemsJewel05 () {
        return _.where(this.items, { collection: 'JP_Jewel05' })
      },

      itemsJewel06 () {
        return _.where(this.items, { collection: 'JP_Jewel06' })
      },

      itemsFCDXSet2 () {
        return _.where(this.items, { collection: 'JP_FCDXSet2' })
      },

      itemsJewelPactBenefit () {
        return _.where(this.items, { collection: 'JP_JewelPactBenefit' })
      },

      itemsDesignPaletteBenefit () {
        return _.chain([])
          .union(_.where(this.items, { collection: 'JP_DP_SherbetPink' }))
          .union(_.where(this.items, { collection: 'JP_DP_EternalWhite' }))
          .union(_.where(this.items, { collection: 'JP_DP_JewelPink' }))
          .value()
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="ジュエルパクトコーデ" color="#c598ff" :items="itemsJewelPact" />
    </template>

    <template #col2>
      <ItemList title="プリチケパック1連動" color="#c598ff" :items="itemsPritickePack01" />
    </template>

    <template #col3>
      <ItemList title="プリチケパック2連動" color="#c598ff" :items="itemsPritickePack02" />
    </template>

    <template #col4>
      <ItemList title="プリチケパック3連動" color="#c598ff" :items="itemsPritickePack03" />
    </template>

    <template #col5>
      <ItemList title="キラキラパック1•2連動" color="#c598ff" :items="itemsKiraKiraPack0102" />
    </template>

    <template #col6>
      <ItemList title="ジュエル1弾連動" color="#c598ff" :items="itemsJewel01" />
      <ItemList title="ジュエル2弾連動" color="#c598ff" :items="itemsJewel02" />
      <ItemList title="ジュエル3弾連動" color="#c598ff" :items="itemsJewel03" />
      <ItemList title="ジュエル4弾連動" color="#c598ff" :items="itemsJewel04" />
      <ItemList title="ジュエル5弾連動" color="#c598ff" :items="itemsJewel05" />
      <ItemList title="ジュエル6弾連動" color="#c598ff" :items="itemsJewel06" />
    </template>

    <template #col7>
      <ItemList title="ファイル＆コーデDX2連動" color="#c598ff" :items="itemsFCDXSet2" />
      <ItemList title="ジュエルパクト早期購入特典" color="#c598ff" :items="itemsJewelPactBenefit" />
      <ItemList title="デザインパレット特典連動" color="#c598ff" :items="itemsDesignPaletteBenefit" />
      <Status :date="date" :items="items" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    right: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
